var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctValue, FctValueList } from '../../../../Fct/generics';
import { getAllCurrencies } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { isNative, OneInchHelper } from '../helpers';
export var SimpleSwap1Inch = createPlugin({
    protocol: '1INCH',
    type: 'ACTION',
    method: 'unoswap',
    name: 'simpleSwap1Inch',
    supportedContracts: [
        { address: '0x1111111254EEB25477B68fb85Ed929f73A960582', chainId: 1 },
        { address: '0x1111111254EEB25477B68fb85Ed929f73A960582', chainId: 42161 },
        { address: '0x1111111254EEB25477B68fb85Ed929f73A960582', chainId: 10 },
        { address: '0x1111111254EEB25477B68fb85Ed929f73A960582', chainId: 8453 },
    ],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                value: new FctValue({ required: false, decimals: 18 }),
                currencyIn: new FctAddress({ mode: 'INPUT', destination: 'erc20', options: getAllCurrencies({ chainId: chainId }) }),
                currencyOut: new FctAddress({ mode: 'INPUT', destination: 'erc20', options: getAllCurrencies({ chainId: chainId }) }),
                amountIn: new FctValue({ mode: 'INPUT', destination: 'wei_amount' }),
                amountOut: new FctValue({ readonly: true, destination: 'wei_amount' }),
                methodParams: {
                    srcToken: new FctAddress({ readonly: true, destination: 'erc20' }),
                    amount: new FctValue({ readonly: true, destination: 'wei_amount' }),
                    minReturn: new FctValue({ destination: 'wei_amount' }),
                    pools: new FctValueList({ readonly: true }),
                    executor: new FctAddress({ readonly: true }),
                    desc_tuple: {
                        srcToken: new FctAddress({ readonly: true, destination: 'erc20' }),
                        dstToken: new FctAddress({ readonly: true, destination: 'erc20' }),
                        srcReceiver: new FctAddress({ readonly: true }),
                        dstReceiver: new FctAddress({}),
                        amount: new FctValue({ readonly: true, destination: 'wei_amount' }),
                        minReturnAmount: new FctValue({ readonly: true }),
                        flags: new FctValue({ readonly: true }),
                    },
                    permit: new FctBytes({ readonly: true }),
                    data: new FctBytes({ readonly: true }),
                },
            },
            output: {
                returnAmount: new FctValue({}),
            },
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var chainId = _a.chainId, input = _a.input, provider = _a.provider, setMethod = _a.setMethod, account = _a.account;
        var helper = new OneInchHelper({ chainId: chainId, provider: provider, account: account });
        var _b = input.methodParams, srcToken = _b.srcToken, amount = _b.amount, minReturn = _b.minReturn, pools = _b.pools, executor = _b.executor, permit = _b.permit, data = _b.data, desc_tuple = _b.desc_tuple;
        var unoswapMethodParams = { srcToken: srcToken, amount: amount, minReturn: minReturn, pools: pools };
        var getPathParams = function (_a) {
            var service = _a.service;
            return __awaiter(void 0, void 0, void 0, function () {
                var tokenInAddress, tokenOutAddress, amountIn, amount, initParams, res, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            tokenInAddress = input === null || input === void 0 ? void 0 : input.currencyIn.value;
                            tokenOutAddress = input === null || input === void 0 ? void 0 : input.currencyOut.value;
                            if (!tokenInAddress ||
                                !tokenOutAddress ||
                                typeof tokenInAddress !== 'string' ||
                                typeof tokenOutAddress !== 'string')
                                return [2 /*return*/];
                            amountIn = input === null || input === void 0 ? void 0 : input.amountIn;
                            if (!amountIn)
                                return [2 /*return*/];
                            amount = undefined;
                            if (typeof amountIn.value === 'string') {
                                amount = amountIn.value;
                            }
                            if (!amount)
                                return [2 /*return*/];
                            initParams = {
                                value: undefined,
                                amountOut: undefined,
                                methodParams: {
                                    srcToken: undefined,
                                    amount: undefined,
                                    minReturn: undefined,
                                    pools: undefined,
                                    executor: undefined,
                                    desc_tuple: {
                                        srcToken: undefined,
                                        dstToken: undefined,
                                        srcReceiver: undefined,
                                        dstReceiver: undefined,
                                        amount: undefined,
                                        minReturnAmount: undefined,
                                        flags: undefined,
                                    },
                                    permit: undefined,
                                    data: undefined,
                                },
                            };
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, helper.getSwapParams({
                                    input: {
                                        currency: { address: tokenInAddress },
                                        amount: amount,
                                    },
                                    output: {
                                        currency: { address: tokenOutAddress },
                                    },
                                    service: service,
                                })];
                        case 2:
                            res = _b.sent();
                            if (!res) {
                                return [2 /*return*/, {
                                        params: initParams,
                                        error: 'invalid trade',
                                    }];
                            }
                            if (res.methodName === 'swap') {
                                if (setMethod)
                                    setMethod('swap');
                                Object.keys(desc_tuple).forEach(function (key) {
                                    var decTupleKey = key;
                                    desc_tuple[decTupleKey].virtual = false;
                                    desc_tuple[decTupleKey].required = true;
                                });
                                executor.virtual = false;
                                permit.virtual = false;
                                data.virtual = false;
                                Object.keys(unoswapMethodParams).forEach(function (key) {
                                    var unoswapKey = key;
                                    unoswapMethodParams[unoswapKey].virtual = true;
                                    unoswapMethodParams[unoswapKey].value = undefined;
                                    unoswapMethodParams[unoswapKey].required = false;
                                });
                                minReturn.readonly = true;
                                desc_tuple.minReturnAmount.readonly = false;
                            }
                            if (res.methodName === 'uniswapV3Swap') {
                                if (setMethod)
                                    setMethod('uniswapV3Swap');
                                Object.keys(desc_tuple).forEach(function (key) {
                                    var decTupleKey = key;
                                    desc_tuple[decTupleKey].virtual = true;
                                    desc_tuple[decTupleKey].value = undefined;
                                    desc_tuple[decTupleKey].required = false;
                                });
                                executor.virtual = true;
                                executor.required = false;
                                permit.virtual = true;
                                permit.required = false;
                                data.virtual = true;
                                data.required = false;
                                executor.value = undefined;
                                permit.value = undefined;
                                data.value = undefined;
                                minReturn.readonly = false;
                                desc_tuple.minReturnAmount.readonly = true;
                                Object.keys(unoswapMethodParams).forEach(function (key) {
                                    var unoswapKey = key;
                                    unoswapMethodParams[unoswapKey].virtual = false;
                                    unoswapMethodParams[unoswapKey].required = true;
                                });
                                srcToken.virtual = true;
                                srcToken.required = false;
                                srcToken.value = undefined;
                            }
                            if (res.methodName === 'unoswap') {
                                if (setMethod)
                                    setMethod('unoswap');
                                Object.keys(desc_tuple).forEach(function (key) {
                                    var decTupleKey = key;
                                    desc_tuple[decTupleKey].virtual = true;
                                    desc_tuple[decTupleKey].value = undefined;
                                    desc_tuple[decTupleKey].required = false;
                                });
                                executor.virtual = true;
                                executor.required = false;
                                permit.virtual = true;
                                permit.required = false;
                                data.virtual = true;
                                data.required = false;
                                executor.value = undefined;
                                permit.value = undefined;
                                data.value = undefined;
                                minReturn.readonly = false;
                                desc_tuple.minReturnAmount.readonly = true;
                                Object.keys(unoswapMethodParams).forEach(function (key) {
                                    var unoswapKey = key;
                                    unoswapMethodParams[unoswapKey].virtual = false;
                                    unoswapMethodParams[unoswapKey].required = true;
                                });
                            }
                            if (res.params.methodParams.minReturn) {
                                res.params.methodParams.minReturn = '0';
                            }
                            if (res.params.methodParams.desc_tuple &&
                                typeof res.params.methodParams.desc_tuple === 'object' &&
                                'minReturnAmount' in res.params.methodParams.desc_tuple) {
                                res.params.methodParams.desc_tuple.minReturnAmount = '1';
                            }
                            return [2 /*return*/, {
                                    params: {
                                        amountOut: res.outputAmount,
                                        value: res.params.value,
                                        methodParams: res.params.methodParams,
                                    },
                                    error: undefined,
                                }];
                        case 3:
                            e_1 = _b.sent();
                            return [2 /*return*/, {
                                    params: initParams,
                                    error: e_1.message,
                                }];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        return { get: getPathParams, depParamKeys: ['currencyIn', 'currencyOut', 'amountIn'] };
    },
    requiredApprovals: function (params) {
        var currencyIn = params.currencyIn, amountIn = params.amountIn;
        if (currencyIn.value && typeof currencyIn.value === 'string' && isNative(currencyIn.value))
            return [];
        return [
            {
                to: currencyIn.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: amountIn.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
